import * as React from "react";
import { useEffect, useState } from "react";
import TableCell from "@mui/material/TableCell";
import Checkbox from "@mui/material/Checkbox";
import { MoreHoriz } from "@mui/icons-material";
import {
  IAdminTransaction,
  IAPIResponse,
  IBuyerTransaction,
  IFilterFetch,
  IListings,
} from "../../../../common/utils/interfaces";
import CustomTable, {
  HeadCell,
} from "../../../../common/components/CustomTable/CustomTable";
import {
  getMyListings,
  getSellerTransactions,
  uploadPropertyDocument,
} from "../../../../../apis/listings/sellers";
import CustomBadge from "../../../../common/components/CustomBadge";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../store/store";
import { Menu, MenuItem, Modal, Typography } from "@mui/material";
import { CustomModalProps } from "../../../../../types";
import { sellerGetTransactionDetails } from "../../../../../apis/seller/transaction";

type Props = {
  setDetailData: (arg: IListings) => void;
};

const testt = [
  {
    transactionDate: "12/05/2024 5:40pm",
    paymentType: "Virtual Tour",
    propertyName: "Ms Homes Ltd",
    paymentStautus: "pending",
  },
  {
    transactionDate: "12/05/2024 5:40pm",
    paymentType: "Virtual Tour",
    propertyName: "Ms Homes Ltd",
    paymentStautus: "pending",
  },
  {
    transactionDate: "12/05/2024 5:40pm",
    paymentType: "Virtual Tour",
    propertyName: "Ms Homes Ltd",
    paymentStautus: "pending",
  },
  {
    transactionDate: "12/05/2024 5:40pm",
    paymentType: "Virtual Tour",
    propertyName: "Ms Homes Ltd",
    paymentStautus: "pending",
  },
  {
    transactionDate: "12/05/2024 5:40pm",
    paymentType: "Virtual Tour",
    propertyName: "Ms Homes Ltd",
    paymentStautus: "pending",
  },
];

const headCells: readonly HeadCell[] = [
  {
    id: "transactionDate",
    numeric: false,
    disablePadding: true,
    label: "Transaction Date",
  },
  {
    id: "paymentType",
    numeric: false,
    disablePadding: false,
    label: "Payment Type",
  },
  {
    id: "propertyName",
    numeric: false,
    disablePadding: false,
    label: "Property Name",
  },
  {
    id: "paymentStautus",
    numeric: false,
    disablePadding: false,
    label: "Payment Status",
    align: "center",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "Actions",
    align: "center",
  },
];

const TransactionsTable: React.FC<Props> = ({ setDetailData }: Props) => {
  const { layoutSearchText, layoutStatusFilter } = useSelector(
    (state: RootState) => state.search
  );
  const [anchorEl, setAnchorEl] = React.useState<
    (EventTarget & SVGSVGElement) | null
  >();
  const [tableData, setTableData] = React.useState<IListings[]>([]);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [selectedTransaction, setSelectedTransaction] =
    useState<IAdminTransaction>();
  const tableTitle = { mainText: "My Transactions", subText: "transactions" };

  useEffect(() => {
    fetchTableData();
  }, [layoutSearchText, layoutStatusFilter]);

  const fetchTableData = async () => {
    const result: IAPIResponse | undefined = await getSellerTransactions({
      filter: layoutStatusFilter,
      search: layoutSearchText,
    });
    if (result) {
      let { data, count } = result;
      // @ts-ignore
      data = data.filter(
        (tx: IBuyerTransaction) =>
          tx.payment_type == "property_purchase" && tx.status == "successful"
      );
      setTableData(data);
    }
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };

  const getBadgeMode = (text: string) => {
    switch (text) {
      case "approved":
        return "success";

      case "rejected":
        return "error";

      default:
        return "info";
    }
  };

  const selectData = (
    evt: React.MouseEvent<HTMLSpanElement, MouseEvent>,
    selectedData: IListings
  ) => {
    evt.stopPropagation();

    setDetailData(selectedData);
  };

  const MappedTableRows = ({
    row,
    labelId,
    isItemSelected,
  }: {
    row: IAdminTransaction;
    labelId: string;
    isItemSelected: boolean;
  }) => (
    <>
      <TableCell padding="checkbox">
        <Checkbox
          color="primary"
          checked={isItemSelected}
          inputProps={{
            "aria-labelledby": labelId,
          }}
        />
      </TableCell>
      <TableCell component="th" id={labelId} scope="row" padding="none">
        {formatDate(row.created)}
      </TableCell>
      <TableCell align="left">{row.payment_type}</TableCell>
      <TableCell align="left">{row.listing_name}</TableCell>
      <TableCell align="center">
        <CustomBadge mode={getBadgeMode(row.status)}>{row.status}</CustomBadge>
      </TableCell>
      <TableCell align="center">
        <MoreHoriz
          onClick={(evt) => {
            evt.stopPropagation();
            setSelectedTransaction(row);
            setAnchorEl(evt.currentTarget);
          }}
        />
      </TableCell>
    </>
  );

  interface ActionsMenuProp {
    openApproveModal: () => void;
  }
  const ActionsMenu: React.FC<ActionsMenuProp> = ({ openApproveModal }) => {
    return (
      <Menu
        // setAnchorEl={setAnchorEl}
        anchorEl={anchorEl}
        open={!!anchorEl}
        // id={id}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "center", horizontal: "right" }}
        // verifiedPerms={verifiedPerms}
        // userID={userID}
        // setShowSideBar={setShowSideBar}
      >
        <MenuItem
          onClick={() => {
            openApproveModal();
            setAnchorEl(null);
          }}
        >
          Upload Documents
        </MenuItem>
      </Menu>
    );
  };

  return (
    <>
      {showApprovalModal && (
        <SellerDocumentUpload
          handleClose={() => setShowApprovalModal(false)}
          open={showApprovalModal}
          transaction={selectedTransaction!}
        />
      )}
      <CustomTable
        tableTitle={tableTitle}
        headCells={headCells}
        rows={tableData}
        // rows={testt}
        mappedTableRows={MappedTableRows}
      />
      <ActionsMenu openApproveModal={() => setShowApprovalModal(true)} />
    </>
  );
};

export default TransactionsTable;

interface SellerDocumentUploadProps extends CustomModalProps {
  transaction: IAdminTransaction;
}
const SellerDocumentUpload: React.FC<SellerDocumentUploadProps> = ({
  handleClose,
  open,
  transaction,
}) => {
  const [transactionDetails, setTransactionDetails] =
    useState<IAdminTransaction>();
  useEffect(() => {
    const fetchTransactionDetails = async () => {
      const response = await sellerGetTransactionDetails(
        transaction.reference_id
      );
      setTransactionDetails(response);
    };
    fetchTransactionDetails();
  }, []);

  const handleDrop = (e: any) => {
    e.preventDefault();
    e.stopPropagation();

    const fileName = e.target.offsetParent.querySelector("input")?.id;

    // Get files from the drop event
    const droppedFiles = Array.from(e.dataTransfer.files);
    const file: any = droppedFiles[0];

    if (file) {
      const fileExtension = file.name.split(".").pop()?.toLowerCase();

      if (
        fileExtension !== "pdf" &&
        fileExtension !== "jpg" &&
        fileExtension !== "jpeg" &&
        fileExtension !== "png"
      ) {
        alert(`${fileName} must be a pdf, jpeg, jpg, or png file`);
        return;
      }

      setFiles((prevFiles) => ({
        ...prevFiles,
        [fileName]: file,
      }));
    }
  };
  const handleDragOver = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragEnter = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const [files, setFiles] = useState({
    sales_receipt: null,
    letter_of_allotment: null,
    letter_of_allocation: null,
    title_deed: null,
  });

  const uploadFiles = async () => {
    let errors = 0;
    Object.values(files).forEach((file) => {
      if (file === null) {
        errors = errors + 1;
      }
    });

    if (errors > 0) alert("Please upload all required files");
    const requestSuccesful = await uploadPropertyDocument(
      files,
      transactionDetails?.reference_id!
    );
  };
  const handleFileChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    fileName: string
  ) => {
    const file = event.target.files?.[0];
    const maxFileSize = 10 * 1024 * 1024;
    if (file) {
      if (file?.size > maxFileSize) {
        return alert("file size should not be more than 10 MB");
      }
      const fileExtension = file.name.split(".").pop()?.toLowerCase();
      // Check if file type is PDF
      if (
        fileExtension !== "pdf" &&
        fileExtension !== "jpg" &&
        fileExtension !== "jpeg" &&
        fileExtension !== "png"
      ) {
        alert(`${fileName} must be a pdf, jpeg, jpg, or png file`);
        return;
      }

      setFiles((prevFiles) => ({
        ...prevFiles,
        [fileName]: file,
      }));
    }
  };
  return (
    <Modal onClose={handleClose} open={open}>
      <div className="absolute p-6 max-h-[85vh] max-w-[80vw] overflow-auto space-y-10 bg-white top-[50%] translate-y-[-50%] left-[50%] translate-x-[-50%] w-[90%] sm:w-[1124px] outline-none">
        <div className="info-card !px-6 sm:!px-10">
          <div className="info-card-header grid sm:grid-cols-2">
            <Typography variant="h5">Property Information</Typography>
            <Typography className="hidden sm:block" variant="h5">
              Buyer Information
            </Typography>
          </div>
          <div className="grid gap-y-6 sm:grid-cols-2">
            <div className="grid h-fit gap-4 sm:gap-7">
              <div className="_section">
                <div className="_title">
                  <Typography>Property Name</Typography>
                </div>
                <div className="_data">
                  <Typography style={{ textTransform: "capitalize" }}>
                    {transactionDetails?.listing.name}
                  </Typography>
                </div>
              </div>
              <div className="_section">
                <div className="_title">
                  <Typography>Address</Typography>
                </div>
                <div className="_data">
                  <Typography style={{ textTransform: "capitalize" }}>
                    {transactionDetails?.listing.full_address}
                  </Typography>
                </div>
              </div>
              <div className="_section">
                <div className="_title">
                  <Typography>Price</Typography>
                </div>
                <div className="_data">
                  <Typography style={{ textTransform: "capitalize" }}>
                    {transactionDetails?.listing.price}
                  </Typography>
                </div>
              </div>
            </div>
            <div className="grid gap-4 sm:gap-y-7">
              <div className="info-card-header sm:hidden mt-6">
                <Typography variant="h5">Buyer Information</Typography>
              </div>
              <div className="_section">
                <div className="_title">
                  <Typography>Name</Typography>
                </div>
                <div className="_data">
                  <Typography style={{ textTransform: "capitalize" }}>
                    {transactionDetails?.buyer.full_name}
                  </Typography>
                </div>
              </div>
              <div className="_section">
                <div className="_title">
                  <Typography>Email</Typography>
                </div>
                <div className="_data">
                  <Typography style={{ textTransform: "capitalize" }}>
                    {transactionDetails?.buyer.email}
                  </Typography>
                </div>
              </div>
              <div className="_section">
                <div className="_title">
                  <Typography>Phone</Typography>
                </div>
                <div className="_data">
                  <Typography style={{ textTransform: "capitalize" }}>
                    {transactionDetails?.buyer.phone_number}
                  </Typography>
                </div>
              </div>
              <div className="_section">
                <div className="_title">
                  <Typography>Payment Method</Typography>
                </div>
                <div className="_data">
                  <Typography style={{ textTransform: "capitalize" }}>
                    {transactionDetails?.payment_method_name}
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="info-card !px-6 sm:!px-10">
          <div className="info-card-header">
            <Typography variant="h5">Required Documents</Typography>
          </div>

          <div className="grid mt-[25px] sm:grid-cols-4 gap-y-[25px] sm:gap-x-[35px]">
            <div className="">
              <p className="text-[16px] text-textBlack font-medium">
                Sales receipt for property*
              </p>
              <div className="file-container relative">
                <div
                  onDragOver={handleDragOver}
                  onDragEnter={handleDragEnter}
                  onDrop={handleDrop}
                  className="absolute w-full h-full z-1"
                ></div>
                <img src="/assets/images/document-upload.svg" alt="" />
                <h3 className="file-container__title">
                  {files.sales_receipt
                    ? // @ts-ignore
                      files.sales_receipt.name
                    : "Choose a file or drag it and drop here"}
                </h3>
                <span className="file-container__info text-center">
                  JPG, PNG or PDF readable files only <br /> (Upload Limit:
                  10MB)
                </span>
                <input
                  onChange={(e) => handleFileChange(e, "sales_receipt")}
                  className="hidden"
                  type="file"
                  accept=".jpg, .png, .jpeg, .pdf"
                  name=""
                  id={"sales_receipt"}
                />
                <label
                  htmlFor="sales_receipt"
                  className="file-container__button z-10"
                >
                  Browse File
                </label>
              </div>
            </div>
            <div className="">
              <p className="text-[16px] text-textBlack font-medium">
                Letter of allotment (House)*
              </p>
              <div className="file-container relative">
                <div
                  onDragOver={handleDragOver}
                  onDragEnter={handleDragEnter}
                  onDrop={handleDrop}
                  className="absolute w-full h-full z-1"
                ></div>
                <img src="/assets/images/document-upload.svg" alt="" />
                <h3 className="file-container__title">
                  {files.letter_of_allotment
                    ? // @ts-ignore
                      files.letter_of_allotment.name
                    : "Choose a file or drag it and drop here"}
                </h3>
                <span className="file-container__info text-center">
                  JPG, PNG or PDF readable files only <br /> (Upload Limit:
                  10MB)
                </span>
                <input
                  onChange={(e) => handleFileChange(e, "letter_of_allotment")}
                  className="hidden"
                  type="file"
                  accept=".jpeg, .jpg, .png, .pdf"
                  name=""
                  id={"letter_of_allotment"}
                />
                <label
                  htmlFor="letter_of_allotment"
                  className="file-container__button z-10"
                >
                  Browse File
                </label>
              </div>
            </div>
            <div className="">
              <p className="text-[16px] text-textBlack font-medium">
                Letter of allocation (Land)*
              </p>
              <div className="file-container relative">
                <div
                  onDragOver={handleDragOver}
                  onDragEnter={handleDragEnter}
                  onDrop={handleDrop}
                  className="absolute w-full h-full z-1"
                ></div>
                <img src="/assets/images/document-upload.svg" alt="" />
                <h3 className="file-container__title">
                  {files.letter_of_allocation
                    ? // @ts-ignore
                      files.letter_of_allocation.name
                    : "Choose a file or drag it and drop here"}
                </h3>
                <span className="file-container__info text-center">
                  JPG, PNG or PDF readable files only <br /> (Upload Limit:
                  10MB)
                </span>
                <input
                  onChange={(e) => handleFileChange(e, "letter_of_allocation")}
                  className="hidden"
                  type="file"
                  accept=".jpeg, .jpg, .png, .pdf"
                  name=""
                  id={"letter_of_allocation"}
                />
                <label
                  htmlFor="letter_of_allocation"
                  className="file-container__button z-10"
                >
                  Browse File
                </label>
              </div>
            </div>
            <div className="">
              <p className="text-[16px] text-textBlack font-medium">
                Title Deed (House)*
              </p>
              <div className="file-container relative">
                <div
                  onDragOver={handleDragOver}
                  onDragEnter={handleDragEnter}
                  onDrop={handleDrop}
                  className="absolute w-full h-full z-1"
                ></div>
                <img src="/assets/images/document-upload.svg" alt="" />
                <h3 className="file-container__title">
                  {files.title_deed
                    ? // @ts-ignore
                      files.title_deed.name
                    : "Choose a file or drag it and drop here"}
                </h3>
                <span className="file-container__info text-center">
                  JPG, PNG or PDF readable files only <br /> (Upload Limit:
                  10MB)
                </span>
                <input
                  onChange={(e) => handleFileChange(e, "title_deed")}
                  className="hidden"
                  type="file"
                  accept=".jpeg, .jpg, .png, .pdf"
                  name=""
                  id={"title_deed"}
                />
                <label
                  htmlFor="title_deed"
                  className="file-container__button z-10"
                >
                  Browse File
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-y-3 items-center justify-end space-x-4">
          <button
            onClick={handleClose}
            className="bg-[#F8F8F8] order-2 sm:order-1 border-primary rounded-2xl py-[10px] px-[30px] text-primary font-semibold hover:opacity-70"
          >
            CANCEL
          </button>
          <button
            onClick={uploadFiles}
            className="bg-primary order-1 sm:order-2 rounded-lg py-[10px] px-[30px] text-[#F8F8F8] font-semibold hover:opacity-70"
          >
            SUBMIT DOCUMENTS FOR REVIEW
          </button>
        </div>
      </div>
    </Modal>
  );
};
